/**
 * Utility functions for AI lock duration formatting and stale detection.
 */

/**
 * Format duration in seconds to a human-readable string like "2m 30s"
 */
export function formatLockDuration(durationMs: number): string {
  if (durationMs < 0) return '0s';

  const totalSeconds = Math.floor(durationMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }
  return `${seconds}s`;
}

/**
 * Calculate duration since a given ISO timestamp
 */
export function getDurationSince(isoTimestamp: string): number {
  const timestamp = Date.parse(isoTimestamp);
  if (!Number.isFinite(timestamp)) return 0;
  return Math.max(0, Date.now() - timestamp);
}

/**
 * Check if a lock is stale based on last activity
 */
export function isLockStale(
  lastActivity: string | undefined,
  lockedAt: string,
  timeoutMinutes: number
): boolean {
  if (timeoutMinutes <= 0) return false;

  const reference = lastActivity ?? lockedAt;
  const referenceMs = Date.parse(reference);
  if (!Number.isFinite(referenceMs)) return false;

  return Date.now() - referenceMs >= timeoutMinutes * 60_000;
}
